import { Star } from "@phosphor-icons/react";

/**
 * Display-only star rating (lectura).
 * Props: value (0-5), count, size, showCount
 */
export function StarRating({ value = 0, count = 0, size = 14, showCount = true, className = "" }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <div className={`inline-flex items-center gap-1 ${className}`} data-testid="star-rating">
      {[0, 1, 2, 3, 4].map((i) => (
        <Star
          key={i}
          size={size}
          weight={i < full || (i === full && half) ? "fill" : "regular"}
          className={i < full || (i === full && half) ? "text-[var(--ag-gold)]" : "text-[var(--ag-text-dim)]/40"}
        />
      ))}
      {showCount && (
        <span className="text-xs text-[var(--ag-text-dim)] ml-1 tabular-nums">
          {value > 0 ? value.toFixed(1) : "—"}
          {count > 0 && <span className="ml-1">({count})</span>}
        </span>
      )}
    </div>
  );
}

/**
 * Interactive star input (formulario).
 */
export function StarInput({ value = 0, onChange, size = 22, testId = "star-input" }) {
  return (
    <div className="inline-flex gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          onClick={() => onChange(i)}
          aria-label={`${i} estrella${i > 1 ? "s" : ""}`}
          className="hover:scale-110 transition-transform"
          data-testid={`${testId}-${i}`}
        >
          <Star
            size={size}
            weight={i <= value ? "fill" : "regular"}
            className={i <= value ? "text-[var(--ag-gold)]" : "text-[var(--ag-text-dim)]/40"}
          />
        </button>
      ))}
    </div>
  );
}
